// ======================================================================
// File Name       : ContentDistributionConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

const STOPPED = 0;
const AVAILABLE = 1;
export const CONTENT_DISTRIBUTION_STATUS = [
  { name: '停止中', value: STOPPED },
  { name: '提供中', value: AVAILABLE },
];

export const COURSE = 0;
export const CONTENT = 1;
export const DISTRIBUTION_TYPE = [
  { name: 'コース', value: COURSE },
  { name: 'コンテンツ', value: CONTENT },
];

export const DRILL = 0;
export const VIDEO = 1;
export const DOCUMENT = 2;
export const LINK = 3;
export const CONTENT_DISTRIBUTION_TYPE = [
  { value: DRILL, name: 'ドリル' },
  { value: VIDEO, name: 'ビデオ' },
  { value: DOCUMENT, name: 'ドキュメント' },
  { value: LINK, name: 'リンク' },
];

export const CONTENT_DISTRIBUTION_CONTENT_TYPE = [
  { value: 0, name: 'ビデオ' },
  { value: 1, name: 'ドリル' },
  { value: 3, name: 'ドキュメント' },
  { value: 5, name: 'リンク' },
];

export const registerDialogSortType = {
  contentSecernId: 0,
  contentName: 2,
  contentType: 1,
};

export const registerSortType = {
  contentSecernId: 0,
  contentName: 2,
  contentType: 1,
  provisionStartDate: 3,
  provisionEndDate: 4,
};

export const DISTRIBUTION_SORT_TYPE = {
  distributionContentSecernId: 0,
  distributionContentType: 1,
  distributionContentName: 2,
  distributionStartDate: 3,
  distributionEndDate: 4,
};

export const DISTRIBUTION_EDIT_TYPE = {
  register: 0,
  update: 1,
  delete: 2,
};
